import React from "react"
import LoggingOrders from '../../../components/organisms/admin/logging/LoggingOrders'
const LoggingOrdersPage = () => {
    return <LoggingOrders />


}
export default LoggingOrdersPage